import { useMemo } from "react";
import { useSelector } from "react-redux";
import { MDBCard, MDBCardBody, MDBCol, MDBRow, MDBTable } from "mdbreact";
import { getAnalytics, money } from "./utils";

const StatCard = ({ label, value, accent = "primary" }) => (
  <MDBCol md="3" className="mb-4">
    <MDBCard className={`border-left border-${accent}`}>
      <MDBCardBody>
        <div className="text-muted small text-uppercase">{label}</div>
        <div className="h4-responsive font-weight-bold mb-0">{value}</div>
      </MDBCardBody>
    </MDBCard>
  </MDBCol>
);

const BreakdownTable = ({ title, rows = [], valueLabel }) => (
  <MDBCol md="6" className="mb-4">
    <MDBCard>
      <MDBCardBody>
        <h5 className="font-weight-bold mb-3">{title}</h5>
        <MDBTable striped bordered small>
          <thead>
            <tr>
              <th>Name</th>
              <th>{valueLabel}</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map(([label, value]) => (
                <tr key={label}>
                  <td>{label}</td>
                  <td>{typeof value === "number" ? money(value) : value}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-center text-muted py-3">
                  No data available.
                </td>
              </tr>
            )}
          </tbody>
        </MDBTable>
      </MDBCardBody>
    </MDBCard>
  </MDBCol>
);

const AnalyticsPanel = () => {
  const { collections } = useSelector(({ dailyCollections }) => dailyCollections);
  const analytics = useMemo(() => getAnalytics(collections), [collections]);

  return (
    <MDBCol md="12">
      <MDBRow>
        <StatCard label="Transactions" value={analytics.transactions} accent="info" />
        <StatCard label="Gross Sales" value={money(analytics.gross)} accent="primary" />
        <StatCard label="Coverage" value={money(analytics.coverage)} accent="success" />
        <StatCard label="Patient Share" value={money(analytics.share)} accent="warning" />
      </MDBRow>

      <MDBRow>
        <BreakdownTable
          title="Payment Breakdown"
          rows={analytics.paymentBreakdown}
          valueLabel="Collected"
        />
        <BreakdownTable
          title="Clinic Breakdown"
          rows={analytics.clinicBreakdown}
          valueLabel="Collected"
        />
      </MDBRow>

      <MDBRow>
        <MDBCol md="12" className="mb-4">
          <MDBCard>
            <MDBCardBody>
              <h5 className="font-weight-bold mb-3">Top Billed Menus</h5>
              <MDBTable striped bordered small>
                <thead>
                  <tr>
                    <th>Menu</th>
                    <th>Times Billed</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics.topMenus.length ? (
                    analytics.topMenus.map(([label, count]) => (
                      <tr key={label}>
                        <td>{label}</td>
                        <td>{count}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center text-muted py-3">
                        No billed menu data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </MDBTable>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBCol>
  );
};

export default AnalyticsPanel;
